<template>
  <div class="w-full h-screen bg-gray-50">
    <Header></Header>
    <loading :active="isLoading"
             :can-cancel="true"
             :on-cancel="onCancel"
             color="#007bff"
             :is-full-page="fullPage"/>
    <div class="container mx-auto max-w-screen-xl px-4">
      <div class="w-full flex items-center justify-between mt-4 mb-2">
        <div class="flex">
          <h2
              class="mb-4 text-2xl font-semibold text-gray-700 dark:text-gray-200"
          >
            Usuários
          </h2>
        </div>

        <div class="flex">
          <router-link
              to="/modulos"
              class="mb-4 text-lg inline-block border hover:bg-gray-100 border-gray-500 rounded py-1 px-3 outline-none focus:outline-none text-gray-800 mr-2">
            <span class="mx-1">Voltar</span>
          </router-link>
          <router-link
              to="/usuario/form"
              class="mb-4 text-lg inline-block border hover:bg-blue-800 border-blue-500 rounded py-1 px-3 bg-blue-500 outline-none focus:outline-none text-white"
          >
            Novo
          </router-link>
        </div>
      </div>

      <Alert :show="alert.show" :type="alert.type" @close="onClose"> {{ alert.texto }} </Alert>

      <form class="mb-2" @submit.prevent="onSubmit">
        <div class="flex items-center space-x-2">
          <label for="nome" class="text-gray-700">E-mail:</label>
          <input id="nome" type="text" v-model="email" class="border border-gray-300 text-gray-700 rounded px-2 py-1 appearance-none outline-none">
          <button class="inline-flex bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600">
            <span>
              <Icone path-icon="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"/>
            </span>
            <span>Pesquisar</span>
          </button>
        </div>
      </form>

      <table class="table-auto min-w-full divide-y divide-gray-200 text-md">
        <thead>
        <tr>
          <th class="border p-2">E-mail</th>
          <th class="border p-2">Ações</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in usuarios" :key="item.id"
            :class="(index % 2) === 0 ? 'bg-gray-100' : ''">
          <td class="border p-2">{{ item.email }}</td>
          <td class="border">
            <div class="flex justify-center">
              <div>
                <router-link :to="{ name: 'usuarioFormId', params: { id: item.id }}"
                             class="text-blue-500 hover:text-blue-800" title="Alterar">
                  <svg class="fill-current" style="width:24px;height:24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z"/></svg>
                </router-link>

              </div>

              <div>
                <button type="button"
                        @click="confirmDelete(item)"
                        class="text-red-500 hover:text-red-800" title="Excluir">
                  <svg class="fill-current" style="width:24px;height:24px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M9,8H11V17H9V8M13,8H15V17H13V8Z"/></svg>

                </button>

              </div>

            </div>

          </td>
        </tr>
        </tbody>
      </table>

      <div class="flex flex-row my-4 justify-around">
        <t-pagination
            :total-items="totalRows"
            :per-page="perPage"
            :limit="limit"
            :disabled="disabled"
            v-model="currentPage"
            @change="changePage()"
        />
      </div>


    </div>

    <div>
      <t-modal header="Confirmar Exclusão" v-model="showModal">
          <span class="text-gray-900">
            Deseja realmente excluir este e-mail:
            <strong>{{ usuario.email }}</strong>?</span>
        <template v-slot:footer>
          <div class="flex justify-between">
            <button type="button" @click="showModal=false"
                    class="mx-3 bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center outline-none focus:outline-none">
              Cancelar
            </button>

            <button type="button" @click="onDelete()"
                    class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded inline-flex items-center  outline-none focus:outline-none">
              Confirmar
            </button>
          </div>
        </template>
      </t-modal>
    </div>
    <Footer></Footer>


  </div>
</template>

<script>
import axios from "@/axios-auth";
import Header from "@/components/layout/Header.vue";
import paginationMixin from "@/mixins/paginationMixin";
import Icone from "@/components/base/Icone.vue";
import loadingMixin from "@/mixins/loadingMixin";
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import utilMixin from "@/mixins/utilMixin";
import Alert from "@/components/base/Alert.vue";
import Footer from "@/components/layout/Footer.vue";


export default {
  mixins: [paginationMixin, loadingMixin, utilMixin],
  components: {Footer, Alert, Icone, Header, Loading},
  data: () => ({
    showDialog: false,
    showModal: false,
    email: null,
    usuario: {id: null, email: null},
    usuarios: [],
  }),
  mounted() {
    this.findAll(0);
  },
  methods: {
    async findAll(page = 0) {
      this.isLoading = true;
      let params = new URLSearchParams();
      params.append("page", page > 0 ? page - 1 : page);
      params.append("size", 12);

      if (this.email) {
        params.append("email", this.email);
      }

      try {
        const resp = await axios.get('usuario', {params: params});
        this.usuarios = resp.data.content;
        this.totalRows = resp.data.totalElements;
        this.perPage = resp.data.size;

      } catch (error) {
        this.setAlert('danger', error.response.data.message)
      } finally {
        this.isLoading = false
      }
    },
    onSubmit() {
      if(this.currentPage > 1) {
        this.currentPage = 1;
      } else {
        this.findAll(0);
      }

    },
    changePage() {
      this.findAll(this.currentPage);
    },
    confirmDelete(item) {
      this.usuario = item;
      this.showModal = true;
    },
    onDelete() {
     this.isLoading = true;

      axios.delete(`usuario/${this.usuario.id}`).then(() => {
        this.onSubmit();
        this.setAlert("success", "Registro excluído com sucesso");
      }).catch(err => {
        this.setAlert("danger", err.response.data.message);
      }).finally(() => this.isLoading = false);

      this.showModal = false

    },
    onClose() {
      this.alert.show = false;
    }
  }
}


</script>
